var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinkish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 70,
    viewBox: "0 0 288 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M252.562 69.125L37.8962 69.125C19.015 69.125 3.70865 53.8187 3.70865 34.9374C3.70865 16.0562 19.0149 0.749908 37.8962 0.749902L252.562 0.749898C271.444 0.749892 286.75 16.0562 286.75 34.9374C286.75 53.8187 271.444 69.125 252.562 69.125Z",
    fill: "#F3F6FF",
    stroke: "#FF7369",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5053,
    cy: 35.3725,
    r: 34.5025,
    transform: "rotate(-180 34.5053 35.3725)",
    fill: "#FF7369"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkish);
export default __webpack_public_path__ + "static/media/pinkish.9bbe10e7a689e9ca33d6dad3f5372151.svg";
export { ForwardRef as ReactComponent };